import { cn } from '@/utils/cn';

import styles from './card.module.css';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: 'md' | 'lg';
}

export function Card({ children, className, padding = 'lg', ...rest }: CardProps) {
  return (
    <div className={cn(styles.card, styles[padding], className)} {...rest}>
      {children}
    </div>
  );
}

